export const COOKIE_NAMES = {
  REFRESH_TOKEN: "refresh_token",
  ACCESS_TOKEN: "access_token",
  REDIRECT_URL: "redirect_url",
}

export const EXTERNAL_COOKIE_NAMES = {
  ACCESS_TOKEN: "external_access_token",
  REDIRECT_URL: "redirect_url",
}

export const AUTH_COOKIE_MAX_AGE_SECONDS = 24 * 60 * 60
/**
 * Attributes for the platform's first-party auth cookies written client-side
 * (SSO callback, token refresh, and the /external/probing + /external/coach
 * handoffs). `Secure` is gated on protocol because the browser silently drops
 * a Secure cookie over plain http, which would leave every subsequent request
 * unauthenticated in local dev.
 *
 * Write-only: this carries a max-age, so never use it to clear a cookie.
 *
 * Deliberately not the Swayam `tokenCookieSecurity()` helper — that one is
 * scoped to the cross-site iframe and yields `SameSite=None; Partitioned`,
 * which must not be applied to the platform's first-party cookies.
 */
export const authCookieAttributes = (): string => {
  const isHttps = typeof window !== "undefined" && window.location.protocol === "https:"
  return `path=/; max-age=${AUTH_COOKIE_MAX_AGE_SECONDS}; SameSite=Lax${isHttps ? "; Secure" : ""}`
}
